import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, envelopeError } from '@/views/skud/shared/modules/skud-http'

export class SkudCommonEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  async ping (name) {
    const res = await this.webApi.post(`${this.url}ping`, { name: name })
    return unwrapEnvelope(res)
  }

  // GET /places/{placeId}/points — список точек места: data: [{id, name, direction}].
  // -> массив точек или null (ошибка — фронт деградирует в свободный ввод).
  async getPoints (placeId) {
    const res = await this.webApi.get(this.url + 'places/' + placeId + '/points')
    this.lastError = res
    const data = unwrapEnvelope(res)
    return Array.isArray(data) ? data : (data && Array.isArray(data.items) ? data.items : null)
  }

  // DELETE /places/{placeId}/points/{pointId}/device — отзыв привязки device-id терминала (api_doc, 2026-09-07).
  // WebApi.delete не отдаёт тело конверта (status revoked/not_bound) — только факт успеха.
  // -> {ok:true} | {ok:false, error}.
  async deletePointDevice (placeId, pointId) {
    const res = await this.webApi.delete(this.url + 'places/' + placeId + '/points/' + pointId + '/device')
    if (res === true) return { ok: true }
    return { ok: false, error: envelopeError(res) || 'Ошибка удаления device-id' }
  }
}
